var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190 190",
    enableBackground: "new 0 0 190 190",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Base_Circle",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: -76.001,
    cy: 55.25,
    r: 77.25
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 142.501,
    cy: 55.25,
    r: 77.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Instructions_and_Tone"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EAEAEA",
    cx: 105.625,
    cy: 100.864,
    r: 77.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000183969557316576581810000012154686032009103235_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M85.853,169.341c-43.411,0-78.728-35.317-78.728-78.728c0-43.41,35.316-78.727,78.728-78.727 c21.545,0,41.656,8.536,56.628,24.036c0.94,0.972,0.913,2.522-0.059,3.46c-0.973,0.939-2.524,0.913-3.461-0.059 c-14.042-14.536-32.902-22.542-53.108-22.542c-40.712,0-73.833,33.121-73.833,73.832c0,40.71,33.121,73.832,73.833,73.832 c40.711,0,73.832-33.122,73.832-73.832c0-8.669-1.487-17.155-4.421-25.226c-0.462-1.271,0.193-2.675,1.464-3.137 c1.27-0.462,2.673,0.192,3.136,1.464c3.131,8.608,4.717,17.658,4.717,26.898C164.58,134.024,129.263,169.341,85.853,169.341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F56BD6",
    d: "M100.364,98.586c-0.403,0-0.81-0.026-1.211-0.08c-2.742-0.367-4.57-2.12-5.552-3.061 c-3.551-3.402-6.395-7.1-9.48-11.232c-1.578-2.113-3.278-4.104-5.078-6.21c-1.1-1.289-2.238-2.622-3.346-3.985 c-0.256-0.315-0.857-1.054-1.178-2.197c-0.524-1.876-0.032-3.883,1.311-5.363c0.746-0.824,1.539-1.257,1.966-1.488 c0.774-0.421,1.522-0.971,2.388-1.609c0.599-0.439,1.201-0.883,1.839-1.309c1.218-0.816,3.113-1.9,5.501-1.9 c0.602,0,1.203,0.07,1.785,0.208c2.893,0.687,4.922,2.864,6.366,4.686c1.614,2.032,2.871,4.159,4.086,6.217 c1.069,1.809,2.082,3.523,3.241,5.003c7.618-4.306,14.968-10.318,22.129-16.762c-3.331-0.521-6.572-1.476-9.637-2.787 c-1.984-0.849-3.813-1.972-5.552-3.26c-4.027-2.988-7.588-6.898-11.399-10.378c-2.068-1.89-4.188-3.74-6.199-5.78 c-1.309-1.328-5.735-8.369-7.324-7.835c-1.909,0.643-3.441,4.011-4.758,5.582c-2.167,2.584-4.576,4.912-6.895,7.187 c-4.229,4.147-8.576,7.945-13.034,11.37c-7.159,5.502-18.096,6.148-26.538,5.222c0.218,3.662,2.303,7.639,2.956,11.266 c1.003,5.573,2.346,10.813,3.967,15.97c3.558,11.319,7.586,21.818,12.009,31.474c3.608,7.884,7.972,14.256,13.736,19.763 c4.286,4.095,14.293,14.997,19.848,14.481c5.275,0.029,20.115-14.133,22.906-17.525c2.665-3.24,4.941-6.948,7.215-10.737 c4.912-8.186,10.818-17.341,13.661-27.826c1.78-6.563,3.611-13.137,5.109-20.046c-9.796,7.85-19.896,15.377-30.472,21.765 C103.451,98.179,101.942,98.586,100.364,98.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F56BD6",
    d: "M162.341,36.717c-0.589-0.615-1.269-1.272-2.119-1.304c-0.022-0.001-0.044-0.001-0.066-0.001 c-0.733,0-1.387,0.469-1.97,0.924c-8.771,6.846-17.379,15.406-26.229,23.578c-8.602,7.944-17.432,15.521-26.873,20.796 c-0.819,0.457-1.727,0.906-2.641,0.906c-0.197,0-0.396-0.021-0.595-0.067c-1.009-0.238-1.742-1.084-2.397-1.888 c-2.923-3.581-4.733-7.949-7.61-11.573c-1.426-1.797-2.571-2.706-3.662-2.966c-0.221-0.052-0.44-0.075-0.655-0.075 c-1.005,0-1.947,0.517-2.777,1.071c-1.581,1.06-2.934,2.238-4.61,3.151c-0.243,0.132-0.49,0.267-0.675,0.472 c-0.187,0.205-0.301,0.495-0.227,0.762c0.045,0.16,0.153,0.297,0.26,0.427c2.829,3.481,5.854,6.747,8.549,10.355 c2.775,3.718,5.585,7.408,8.944,10.626c0.813,0.778,1.703,1.594,2.816,1.744c0.185,0.024,0.372,0.037,0.56,0.037 c0.644,0,1.293-0.148,1.836-0.475c11.99-7.244,23.327-15.957,34.447-25.045c10.294-8.413,20.403-17.147,30.667-25.349 C163.931,39.296,165.723,40.245,162.341,36.717"
  })))));
};
export default __webpack_public_path__ + "static/media/Icons_Selected_05_Shield.52cc720b.svg";
export { SvgComponent as ReactComponent };